<template>
    <div class="tooltip" @mouseenter="enter" @mouseleave="leave">
        <div class="tooltip-bulle" :class="'pos-'+position" :style="style">
            {{text}}
        </div>
        <slot/>
    </div>
</template>

<script>
export default {
    name: "tooltip",
    props:{
        delay:{type:String,default:"0s"},
        text:String,
        position:{type:String,default:"top"},
    },
    data(){
      return {
          style:"",
      }
    },
    methods:{
        enter(){
            this.style =  "transition-delay:"+this.delay
        },
        leave(){
            this.style = "";
        }
    }
}
</script>